import Dialog from "@mui/material/Dialog";
import { PaperProps } from "@mui/material/Paper";
import { FC, useEffect } from "react";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { useTheme } from "styled-components";
import { isBrowser } from "utils/nookies/utils";

interface IModal {
  children: ReactJSXElement;
  open: boolean;
  onClose?: (evt?) => void;
  isFullScreen?: boolean;
  isBottom?: boolean;
  width?: string;
  height?: string;
  modalKey?: string | number;
  isNested?: boolean;
  disableOverlay?: boolean;
  disabledTransition?: boolean;
  isGrayBg?: boolean;
  disableEnforceFocus?: boolean;
  showScroll?: boolean;
  className?: string;
}

const Modal: FC<IModal> = ({
  children,
  open,
  onClose,
  width,
  height,
  isFullScreen = false,
  isBottom = false,
  modalKey,
  isNested = false,
  disableOverlay = false,
  disabledTransition = false,
  isGrayBg = false,
  disableEnforceFocus = false,
  showScroll = false,
  className = "",
}) => {
  const { isMobile, isDesktop, locale } = useTheme();
  const defaultsStyle: Partial<PaperProps<"div", {}>> = {
    style: {
      width: isBottom ? "100%" : width,
      height: isFullScreen && !isBottom ? "100%" : height ? height : "auto",
      maxHeight: !isFullScreen && !isBottom ? "90vh" : "100%",
      maxWidth: !isFullScreen && !isBottom ? "90%" : "100%",
      overflowY: !isFullScreen && isDesktop && !showScroll ? "initial" : "auto",
      background: isGrayBg ? "#f2f2f7" : "#fff",
      textAlign: locale === "ar" ? "right" : "left",
      margin: "0",
      borderRadius: !isFullScreen
        ? "8px"
        : isBottom
        ? "20px 20px 0 0"
        : "unset",
      position: isBottom ? "absolute" : "unset",
      left: isBottom ? "0" : "unset",
      bottom: isBottom ? "0" : "unset",
    },
  };

  useEffect(() => {
    if (isMobile && isBrowser() && navigator?.userAgent.includes("iPhone")) {
      let prevScrollPosition = window.scrollY;
      // Add or remove class to body element based on dialog open state
      if (!isNested) {
        if (open) {
          prevScrollPosition = window.scrollY;
          document.querySelector("html").style.overflow = "hidden";
          document.querySelector("html").style.height = "100%";
          document.body.style.height = "100%";
        } else {
          document.querySelector("html").removeAttribute("style");
          document.body.removeAttribute("style");
          window.scrollTo(0, prevScrollPosition);
        }
        // Clean up the effect when the component unmounts or the dependency changes
        return () => {
          document.querySelector("html").removeAttribute("style");
          document.body.removeAttribute("style");
          window.scrollTo(0, prevScrollPosition);
        };
      }
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      fullScreen={isFullScreen}
      onClose={onClose}
      maxWidth={false}
      PaperProps={defaultsStyle}
      scroll={isDesktop ? "body" : "paper"}
      key={modalKey}
      hideBackdrop={disableOverlay}
      transitionDuration={disabledTransition ? 0 : 225}
      className={className}
      disableEnforceFocus={disableEnforceFocus}
    >
      {children}
    </Dialog>
  );
};
export default Modal;
